import { useMemo } from "react";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves locations data.
 * @returns - A promise that resolves to the location data.
 */
export const useFetchLocations = () => {
  const memoizedFetchLocations = useMemo(
    () => async (pulloutDivision) => {
      return apiGet(`/locations/${pulloutDivision}`, "fetching locations");
    },
    []
  );

  return memoizedFetchLocations;
};
